// AUTO-GENERATED by build/islands/build-islands.mjs — do not edit.

/** @type {Record<string, () => Promise<{ default: import('react').ComponentType<any> }>>} */
export const islandLoaders = {
	cart_slideout: () => import('../../templates/components/cart_slideout/cart_slideout.mjs'),
	demo: () => import('../../templates/modules/demo/demo.mjs'),
	powered_by_rp: () => import('../../templates/modules/powered_by_rp/powered_by_rp.mjs'),
	product_brand_and_store: () => import('../../templates/modules/product_brand_and_store/product_brand_and_store.mjs'),
	product_media: () => import('../../templates/modules/product_media/product_media.mjs'),
	product_offer: () => import('../../templates/modules/product_offer/product_offer.mjs'),
	product_overview: () => import('../../templates/modules/product_overview/product_overview.mjs'),
	product_recently_viewed: () => import('../../templates/modules/product_recently_viewed/product_recently_viewed.mjs'),
	product_recommendations: () => import('../../templates/modules/product_recommendations/product_recommendations.mjs'),
	rp_ui_smoke: () => import('../../templates/modules/rp_ui_smoke/rp_ui_smoke.mjs'),
	steer: () => import('../../templates/modules/steer/steer.mjs'),
};
